import { render, staticRenderFns } from "./EditSchoolProfile.vue?vue&type=template&id=35d099dd&"
import script from "./EditSchoolProfile.vue?vue&type=script&lang=js&"
export * from "./EditSchoolProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports